import { render, staticRenderFns } from "./NewsSingleModal.vue?vue&type=template&id=2e073eba&"
import script from "./NewsSingleModal.vue?vue&type=script&lang=js&"
export * from "./NewsSingleModal.vue?vue&type=script&lang=js&"
import style0 from "./NewsSingleModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports